module.exports = __webpack_public_path__ + "static/media/TouchBaseHelpInput.f60a13ff.PNG";